import { ChangeEvent, useState } from "react";
import { Close, HelpOutline } from "@mui/icons-material";
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Popover,
  styled,
  alpha,
  Toolbar,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import { INVISIBLE_INDICATORS_DSA_KEY } from "../../types";

interface Props {
  config: string;
}

export function InvisibleSelectionPopup(props: Props) {
  const { config } = props;
  const [dontShowAgain, setDontShowAgain] = useLocalStorage<boolean>(
    `${INVISIBLE_INDICATORS_DSA_KEY}_${config}`,
    false
  );
  const [open, setOpen] = useState(!dontShowAgain);
  const [popoverAnchor, setPopoverAnchor] = useState<HTMLButtonElement | null>(
    null
  );

  const { t } = useTranslation();

  return (
    <StyledIconButton
      onClick={() => setOpen(!open)}
      size="small"
      ref={(ref) => setPopoverAnchor(ref)}
    >
      <HelpOutline />
      {popoverAnchor && (
        <Popover
          onClose={() => setOpen(!open)}
          anchorEl={popoverAnchor}
          open={open && popoverAnchor !== null}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          PaperProps={{
            variant: "defaultBackground",
            elevation: 12,
            square: false,
          }}
          BackdropProps={{ invisible: false }}
        >
          <Toolbar variant="dense">
            <IconButton
              edge="end"
              sx={{ marginLeft: "auto" }}
              onClick={() => setOpen(false)}
            >
              <Close />
            </IconButton>
          </Toolbar>
          <StyledPopperContent>
            {t("message.someOrAllIndicatorsDontHaveAActiveLayer")}
            <FormControlLabel
              control={
                <Checkbox
                  checked={dontShowAgain}
                  onChange={(
                    _: ChangeEvent<HTMLInputElement>,
                    checked: boolean
                  ) => setDontShowAgain(checked)}
                />
              }
              label={t("label.dontShowAgain").toString()}
            ></FormControlLabel>
          </StyledPopperContent>
        </Popover>
      )}
    </StyledIconButton>
  );
}

const StyledIconButton = styled(IconButton)`
  margin-left: auto;
  color: ${({ theme }) => alpha(theme.palette.grey[200], 0.3)};
`;

const StyledPopperContent = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2, 3)};
  max-width: 23vw;
`;
